import { logHelper } from '@wegic/utils';

interface AbTestImportMeta {
  env?: Record<string, string | undefined>;
}

function getEnv(): Record<string, string | undefined> {
  try {
    return (import.meta as AbTestImportMeta).env ?? {};
  } catch {
    return {};
  }
}

const env = getEnv();
const isDevelopment = env.NODE_ENV === 'development';
const isLocalBrowser = typeof window !== 'undefined' && ['localhost', '127.0.0.1'].includes(window.location.hostname);
const enableDebugLogging = isDevelopment || isLocalBrowser;

export const AB_TEST_CONFIG = {
  appId: Number(env.PUBLIC_VOLCANO_APP_ID) || 698414,
  channel: 'sg',
  sdkTimeout: 10000,
  logging: {
    enabled: enableDebugLogging,
  },
};

const LOG_PREFIX = '[ABTest]';
const LOG_PREFIX_STYLE = {
  background: '#f97316',
  color: '#ffffff',
  fontWeight: '600',
  borderRadius: '3px',
  padding: '1px 4px',
};

function formatLogParts(message: string) {
  return [
    { text: LOG_PREFIX, style: LOG_PREFIX_STYLE },
    { text: ` ${message}` },
  ];
}

export const logger = {
  debug(message: string, ...args: unknown[]) {
    if (AB_TEST_CONFIG.logging.enabled) {
      logHelper.styledDebug(formatLogParts(message), ...args);
    }
  },

  info(message: string, ...args: unknown[]) {
    if (AB_TEST_CONFIG.logging.enabled) {
      logHelper.styledInfo(formatLogParts(message), ...args);
    }
  },

  warn(message: string, ...args: unknown[]) {
    logHelper.styledWarn(formatLogParts(message), ...args);
  },

  error(message: string, ...args: unknown[]) {
    logHelper.styledError(formatLogParts(message), ...args);
  },
};
